import { checkoutAmazonConfig } from "../config/checkoutAmazon";
import { checkoutNiuConfig } from "../config/checkoutNiu";

export function getClientCheckoutConfig({ client }) {
    if (client?.key === "amazon") {
        return checkoutAmazonConfig;
    }

    if (client?.key === "niu") {
        return checkoutNiuConfig;
    }

    return null;
}